import { useMutation } from "react-query";
import {
  fetchAnalysisRevenue,
  fetchAnalysisSample,
  fetchAnalysisV2Sample,
  fetchLogout,
  fetchOauth,
  fetchOauthAuthorization,
  fetchSample,
  fetchSampleDetail,
  fetchSampleProcess,
  fetchShowCase,
  fetchUserInfo,
  fetchUserLevelRules,
  fetchUserOverview,
} from ".";

export const useOauth = () => useMutation(fetchOauth);
export const useOauthAuthorization = () => useMutation(fetchOauthAuthorization);
export const useUserInfo = () => useMutation(fetchUserInfo);
export const useLogout = () => useMutation(fetchLogout);
export const useShowCase = () => useMutation(fetchShowCase);
export const useSample = () => useMutation(fetchSample);
export const useSampleDetail = () => useMutation(fetchSampleDetail);
export const useSampleProcess = () => useMutation(fetchSampleProcess);
export const useUserLevelRules = () => useMutation(fetchUserLevelRules);
export const useUserOverview = () => useMutation(fetchUserOverview);
export const useAnalysisRevenue = () => useMutation(fetchAnalysisRevenue);
export const useAnalysisSample = () => useMutation(fetchAnalysisSample);
export const useAnalysisV2Sample = () => useMutation(fetchAnalysisV2Sample);
